import axios from '@/libs/axios'

const list = ({ commit }, data) => new Promise((resolve, reject) => {
  axios.get(`/apply-document/${data.id}/scientific-work-list/`, { params: data })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const create = (ctx, scientificWork) => new Promise((resolve, reject) => {
  const formData = new FormData()
  formData.append('scientific_work_name', scientificWork.scientific_work_name)
  formData.append('publication_date', scientificWork.publication_date)
  formData.append('scientific_work_type', scientificWork.scientific_work_type)
  if (scientificWork.scientific_work_url) formData.append('scientific_work_url', scientificWork.scientific_work_url)
  if (scientificWork.file instanceof File) formData.append('scientific_work', scientificWork.file)

  const applyDocumentId = scientificWork.applyDocument.id
  if (scientificWork.id) {
    axios.patch(`/apply-document/${applyDocumentId}/change-scientific-work/`, formData, { params: { scientific_work_id: scientificWork.id } })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  } else {
    axios.post(`/apply-document/${applyDocumentId}/add-scientific-work/`, formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  }
})

const del = (ctx, data) => new Promise((resolve, reject) => {
  axios.delete(`/apply-document/${data.apply_document}/scientific-work-delete/`, { params: { scientific_work_id: data.id } })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
export default {
  create,
  list,
  del,
}
